export * from './lib/shared.module';
export * from './lib/components/custom-modal/custom-modal.component';
